export { CollapsibleRoot as Root } from "./root/CollapsibleRoot.js";
export { CollapsibleTrigger as Trigger } from "./trigger/CollapsibleTrigger.js";
export { CollapsiblePanel as Panel } from "./panel/CollapsiblePanel.js";